import type { Sector } from "~/modules/sector/models/Sector.interface";

/**
 * Recursive function to find the parent sector of a given sector
 * @param sectorTree - The current sector (initially the root of the sectors)
 * @param targetCode - Code of the sector whose parent we want to find
 * @param parentSector - Parent code of the current sector (used during recursion)
 * @returns The parent code if found, otherwise undefined
 */
export function findSectorParentInSectorTree(
  sectorTree: Sector,
  targetCode: number,
  parentSector?: Sector,
): Sector | undefined {
  // If the current sector code matches the target code, return the code of its parent
  if (sectorTree.code === targetCode) {
    return parentSector;
  }

  // Recursively search through the children
  for (const child of sectorTree.children) {
    const result = findSectorParentInSectorTree(child, targetCode, sectorTree);
    // If a result is found in one of the subsectors, return it
    if (result) {
      return result;
    }
  }
}
